<template>
    <div class="all">
      <h2>期刊服务</h2>
      <ul>
        <li @click="toExternal(1)"> 
          <img src="@/assets/img/details/bkqktg.png" alt="">
          <div class="conents-left">
            <div>百科期刊推广</div>
            <div>Baike Promotion Service</div>
          </div>
        </li>
        <li @click="toExternal(2)"> 
          <img src="@/assets/img/details/cbmp.png" alt="">
          <div class="conents-right">
            <div>采编名片</div>
            <div>Editorial ID</div>
          </div>
        </li>
        <li @click="toExternal(3)"> 
          <img src="@/assets/img/details/tsgxt.png" alt="">
          <div class="conents-left">
            <div>投审稿系统</div>
            <div>Submission systems</div>
          </div>
        </li>
        <li @click="toExternal(4)"> 
          <img src="@/assets/img/details/qkgw.png" alt="">
          <div class="conents-right">
            <div>期刊官网</div>
            <div>Main Website of the journal</div>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
     name:'index',
    components: {
      // Top
    },
    props: {

    },
    data() {
        return {
          title:'', // 头标题
          type:'' // 类型
        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      toExternal(key) {
        switch (key) {
          case 1: // 百科期刊推广
            this.title = '百科期刊推广'
            this.type = key
            break;
          case 2: // 采编名片
            this.title = '采编名片'
            this.type = key
            break;
          case 3: // 投审稿系统
            this.title = '投审稿系统'
            this.type = key
            break;
          case 4: // 期刊官网
            this.title = '期刊官网'
            this.type = key
            break;
        }
        this.$router.push({
          path:'/JournalOfPromotion',
          query:{
            title:this.title,
            pageType:this.type
          }
        })
      }
    },
};
</script>

<style scoped lang="scss">
.all{
  margin-top: 70px;
  & h2{
    margin-top: -20px;
    padding-left: 20px;
  }
  & ul{
    padding:0px 20px 40px 20px;
    & li{
      & img{
        width: 100%;
        height: 130px;
      }
      & .conents-left{
        float: left;
        position: relative;
        top: -80px;
        left: 50px;
        color: #fff;
        font-size: 12px;
        margin-bottom: -40px;
        & :nth-child(1){
          font-size: 20px;
        }
      }
      & .conents-right{
        float: right;
        position: relative;
        top: -80px;
        right: 50px;
        color: #fff;
        font-size: 12px;
        margin-bottom: -40px;
        text-align:end;
        & :nth-child(1){
          font-size: 20px;
        }
      }
    }
  }
}
</style>
